import { GitRepo } from '../models/git-worker.model';
import { GitCloneGitError } from '../errors/git-clone.git-error';
import { setToken } from '../util/set-token';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitCloneAction extends WorkerAction {
  type: GitAction.Clone;
  params: Omit<GitRepo, 'authTokenFn'> & {
    authToken: string;
    productionMode: boolean;
  };
}

export async function GitCloneActionFn({ lg, fs, params, util }: WorkerFnParams<GitCloneAction>): Promise<void> {
  const { repoDir, url, userName, authToken, userEmail } = params;
  console.debug(`[WasmGit]: cloning url "${url}"`);

  try {
    setToken(authToken);

    lg.callAndCaptureOutput(['clone', url, '.']);
  } catch (err) {
    try {
      fs.rmdir(repoDir);
    } catch (e) {
      // don't care about error
    }

    console.error(`[WasmGit]: git clone failed`, err);
    throw new GitCloneGitError(url);
  }

  try {
    lg.callAndCaptureOutput(['config', 'user.name', userName]);
    lg.callAndCaptureOutput(['config', 'user.email', userEmail]);

    const gitConfig = fs.readFile('.git/config');
    fs.writeFile('/home/web_user/.gitconfig', gitConfig);

    await util.syncfs(false);
  } catch (err) {
    console.error(`[WasmGit]: failed to initialize git config`, err);
    throw new GitCloneGitError(url);
  }
}
